module.exports = __webpack_public_path__ + "img/outros-7db065a1.jpg";